<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title_page_image"><img alt="Scattered Seed by Maisie Mosco" src="images/scale~1920x1200~seedtitlep-1582887634-46.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?c77968cc